declare global {
  interface Window {
    DD_RUM?: { addError: (error: Error, settings: Record<string, unknown>, source: string) => void };
  }
}

/**
 * https://github.com/DataDog/rum-react-integration-examples/blob/master/src/utils/getGlobalObject.ts
 */
export function getGlobalObject<T>(): T {
  if (typeof globalThis === 'object') {
    return globalThis as unknown as T;
  }
  // eslint-disable-next-line functional/immutable-data
  Object.defineProperty(Object.prototype, '_dd_temp_', {
    get() {
      // eslint-disable-next-line @typescript-eslint/ban-types
      return this as object;
    },
    configurable: true,
  });
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore _dd_temp is defined using defineProperty
  let globalObject: unknown = _dd_temp_;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore _dd_temp is defined using defineProperty
  // eslint-disable-next-line functional/immutable-data
  delete Object.prototype._dd_temp_;
  if (typeof globalObject !== 'object') {
    // on safari _dd_temp_ is available on window but not globally
    // fallback on other browser globals check
    if (typeof self === 'object') {
      globalObject = self;
    } else if (typeof window === 'object') {
      globalObject = window;
    } else {
      globalObject = {};
    }
  }
  return globalObject as T;
}
